import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 75A5F242-D136-49B9-9DFF-25F0631743A7
 * name engine-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/engine-outline.svg
 * tags
 * - Automotive 
 */
export const EngineOutlineIcon = createSvgIcon(<><path d="M8,10H16V18H11L9,16H7V11M7,4V6H10V8H7L5,10V13H3V10H1V18H3V15H5V18H8L10,20H18V16H20V19H23V9H20V12H18V8H12V6H15V4H7Z" /></>, 'EngineOutlineIcon');
export default EngineOutlineIcon